module.exports = __webpack_public_path__ + "img/commercial-league-inline-logo.e2b348b1.png";